<form #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Clientes
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso no cadastro de clientes</small>
        </div>
        
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarCliente" name="podeEditarCliente" id="podeEditarCliente">
                    <label class="custom-control-label" for="podeEditarCliente">Editar cliente</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário editar clientes</p>
            </li>            
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeCadastrarClienteExterior" name="podeCadastrarClienteExterior" id="podeCadastrarClienteExterior">
                    <label class="custom-control-label" for="podeCadastrarClienteExterior">Cadastrar cliente do exterior</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário cadastrar clientes do exterior</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarClienteSegmentos" name="podeEditarClienteSegmentos" id="podeEditarClienteSegmentos">
                    <label class="custom-control-label" for="podeEditarClienteSegmentos">Editar segmentos do cliente</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário editar os segmentos dos clientes. Atenção: segmento é um dado sensível que impacta indicadores, campanhas e a classificação dos clientes.</p>
            </li>
        </ul>                               
    </div>
</form>